import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import platformApi, { PLATFORM_TOKEN_KEY, platformErrorMessage } from '../../services/platformApi'
import '../Login/LoginPage.css'

function PlatformLoginPage() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (event) => {
    event.preventDefault()
    setError('')
    setLoading(true)
    try {
      const { data } = await platformApi.post('/api/platform/login', {
        email: email.trim(),
        password,
      })
      localStorage.setItem(PLATFORM_TOKEN_KEY, data.token)
      navigate('/plataforma', { replace: true })
    } catch (err) {
      setError(platformErrorMessage(err, 'Não foi possível entrar'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-page">
      <div className="login-shell">
        <div className="login-brand-panel">
          <p className="login-brand-kicker">Plataforma</p>
          <h1 className="login-brand-title">Organizações</h1>
          <p className="login-brand-copy">
            Cadastro e autorização das empresas. O ERP de cada uma continua separado.
          </p>
        </div>
        <div className="login-container">
          <header className="login-header">
            <p className="login-brand-mark">Acesso restrito</p>
            <h2>Entrar na plataforma</h2>
            <p>Use a conta de operador, não a de uma empresa.</p>
          </header>
          <form className="login-form" onSubmit={handleSubmit}>
            {error ? <p className="login-error">{error}</p> : null}
            <div className="login-form-group">
              <label htmlFor="platform-email">E-mail</label>
              <input
                id="platform-email"
                type="email"
                autoComplete="username"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
              />
            </div>
            <div className="login-form-group">
              <label htmlFor="platform-password">Senha</label>
              <input
                id="platform-password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
              />
            </div>
            <button className="login-submit" type="submit" disabled={loading}>
              {loading ? <Loader2 className="login-spinner" size={18} /> : null}
              Entrar
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default PlatformLoginPage
